export default "__VITE_ASSET__41972982__"